// This file is generated automatically by `scripts/build/fp.ts`. Please, don't change it.

import { addHours as fn } from "../addHours.js";
import { convertToFP } from "./_lib/convertToFP.js";

export const addHours = convertToFP(fn, 2);

// Fallback for modularized imports:
export default addHours;
